/**
 * Resource danh mục nhóm tài khoản
 * ndquang1 16.5.2024
 */
export default {
  Title: 'Kết chuyển tài khoản',
};
